
import { mapGetters, mapActions } from 'vuex'
import { giftWrappingMap } from '@/constants/giftwrapping'
import { addOnPocketMap } from '@/constants/addOnPockets'
import { spiralOptionsMap } from '@/constants/spiralOptions'
import { daysoftheweek } from '@/constants/daysoftheweek'
import { months } from '@/constants/months'
import {
  mdiPlus,
  mdiMinus,
  mdiCartPlus,
  mdiChevronLeft,
  mdiChevronRight,
  mdiLogoutVariant,
  mdiKeyboardReturn,
  mdiOpenInNew,
} from '@mdi/js'

export default {
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://penthejourney.com' + this.$route.path,
        },
      ],
      title: `${this.product.name || 'Product'} ∙ Pen The Journey`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${
            this.product.description ||
            'An awesome product from Pen The Journey'
          }`,
        },
        //Facebook Open Graph Tags
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://penthejourney.com' + this.$route.path,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.product.name || 'Product'} ∙ Pen The Journey`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `${
            this.product.description ||
            'An awesome product from Pen The Journey'
          }`,
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Pen The Journey',
        },
        { hid: 'og:image', property: 'og:image', content: 'ptj.jpg' },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/jpg',
        },
        { hid: 'og:image:height', property: 'og:image:height', content: '800' },
        { hid: 'og:image:width', property: 'og:image:width', content: '800' },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: `An image of ${
            this.product.category || 'Product'
          } from pen the journey`,
        },
        { hid: 'og:type', property: 'og:type', content: 'website' },

        //Twitter tags
        {
          hid: 'twitter:card',
          name: 'twitter:type',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content: 'https://penthejourney.com/' + this.$route.path,
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: `${this.product.name || 'Product'} ∙ Pen The Journey`,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: `${
            this.product.description ||
            'An awesome product from Pen The Journey'
          }`,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://penthejourney.com/',
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content: `An image of ${
            this.product.name || 'Product'
          } from pen the journey`,
        },
      ],
    }
  },
  data() {
    return {
      isDiscColourIssue: false,
      isDiscBoundSelected: false,
      isSpiralSelected: false,
      isImageSizeComparisonDialogVisible: false,
      spiralOptionsMap,
      addOnPocketMap,
      isCustomizationApplied: false,
      isSelectingCoverGraphic: false,
      daysoftheweek,
      isSpreadTextCustomizationDialogShowing: false,
      index: null,
      media: [
        {
          src: 'https://images.unsplash.com/photo-1657299170935-31e068229885?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
          thumb:
            'https://images.unsplash.com/photo-1657299170935-31e068229885?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
        },
      ],
      showLightBoxOnDom: false,
      mdiMinus,
      mdiPlus,
      mdiLogoutVariant,
      mdiKeyboardReturn,
      isIntersecting: false,
      sheet: true,
      ready: false,
      isAddingToCart: false,
      mdiCartPlus,
      product: {},
      images: [],
      customizedProduct: {
        spreadTextCustomization: {
          value: false,
        },
      },
      autoselectMenu: false,
      mdiChevronLeft,
      mdiChevronRight,
      model: null,
      show: true,
      giftWrappingMap,
      pouchCustomization: [
        { value: 'Yes', id: 0, price: 30 },
        { value: 'No', id: 1, price: 0 },
      ],
      coverGraphics: [],
      itemAdded: {},
      showContinueShoppingDialog: false,
      productListener: null,
    }
  },
  computed: {
    ...mapGetters('product', ['selectedProduct']),
    ...mapGetters('cart', ['productsInCart']),
    discColourDisable() {
      const {
        customizedProduct: { binding },
      } = this

      if (!binding) return false

      if (binding.value === 'Spiral/Coil')
        delete this.customizedProduct.discColour

      return binding?.value === 'Spiral/Coil' ? true : false
    },
    sprialColourDisable(){
      const {
        customizedProduct: { binding },
      } = this

      if (!binding) return false

      if (binding.value === 'Disc Binding')
        delete this.customizedProduct.spiralColour

      return binding?.value === 'Disc Binding' ? true : false
    },
    datedWarning() {
      const { datedLayout } = this.customizedProduct
      if (!datedLayout) return false
      if (datedLayout.value === 'Undated') return true
      return false
    },
    minDate() {
      return `${new Date().getFullYear()}-${new Date().getMonth() + 1}`
    },
    maxDate() {
      return `${new Date().getFullYear()}-12`
    },
    saleMessage() {
      const { cost = 0, discount = 0 } = this.product
      if (!cost && !discount) return `Starting at $0.00 TTD`
      const noSaleMessage = `Starting at $${parseFloat(cost)?.toFixed(2)} TTD`
      const discAmt = parseFloat(cost) - parseFloat(discount)
      const saleMessage = `Was $${parseFloat(cost)?.toFixed(
        2
      )} TTD. Now $${discAmt?.toFixed(2)} TTD`
      if (parseFloat(discount) <= 0.0) return noSaleMessage
      return saleMessage
    },
    stockSliderRules() {
      const {
        customizedProduct: { selectedOption },
        product,
      } = this
      if (!product.options?.length || false) return false
      if (!selectedOption) return
      const { stock, stockQuantityAlert } = selectedOption
      //const { orderedQuantity } = this.customizedProduct
      return [(v) => Number(v) <= Number(stock) || `Only ${stock} in stock`]
    },
    stockMessage() {
      const {
        customizedProduct: { selectedOption },
      } = this
      if (!selectedOption) return
      const { stock, stockQuantityAlert } = selectedOption
      return Number(stock) === 0
        ? 'Out of stock'
        : Number(stock) >= Number(stockQuantityAlert)
        ? 'In Stock'
        : `In Stock - ${stock} remaining`
    },
    isAddToCartDisabled() {
      const {
        customizedProduct: { selectedOption },
        product,
      } = this
      if (!product.options?.length || false) return false
      if (!selectedOption) return true
      const { stock, stockQuantityAlert, isStockTrackingEnabled } =
        selectedOption

      const { orderedQuantity } = this.customizedProduct
      return (
        Number(stock) === 0 ||
        !isStockTrackingEnabled ||
        !orderedQuantity ||
        orderedQuantity > stock ||
        product.options.length
      )
    },
    itemTotal() {
      const {
        customizedProduct,
        product: { cost, discount },
      } = this
      if (!customizedProduct) return (0).toFixed(2)
      const { coverGraphic, personalizedText, ...newObj } = customizedProduct
      const v = Object.values(newObj)

      if (!v.length) return (0).toFixed(2)
      const { orderedQuantity } = customizedProduct
      const total = v.reduce((acc, cur) => {
        if (!cur) return acc + 0
        if (!cur.price) return acc + 0
        return acc + Number(cur.price)
      }, 0)
      const itemTotal = Number(total) + Number(cost) - (parseInt(discount) || 0)
      if (orderedQuantity) return (itemTotal * orderedQuantity).toFixed(2)
      else return itemTotal.toFixed(2)
    },
    customizedPouchValue() {
      const { pouchCustomization } = this.customizedProduct
      if (!pouchCustomization) return ''

      const { value, price } = pouchCustomization

      return `${value} (+$${price}TTD)`
    },
    paths() {
      const { yPLayoutImages, infoCompressed } = this.product

      if (!yPLayoutImages?.length && !infoCompressed?.length) return []
      const yPLayoutImagesArr = !yPLayoutImages
        ? []
        : yPLayoutImages.map((im) => im.pathCompressed)
      return [...yPLayoutImagesArr, ...infoCompressed]
    },
  },
  methods: {
    ...mapActions('product', ['getProductFromDbWithLinkName']),
    ...mapActions('cart', ['addToVuexCart', 'removeProductFromVuexCart']),
    disableCoverTypesAccordingToBindingType(){
      // If Spiral Binding is selected disable Frosted Cover. 
      // Enable Laminated Soft and Laminated Hard
      const {binding : {value}} = this.customizedProduct;

      //Also clear users cover type selection everytime they change binding type
      if(this.customizedProduct.cover)  delete this.customizedProduct.cover;

    
      if(value === "Spiral/Coil") {
        this.isSpiralSelected = true;
        this.isDiscBoundSelected = false;
        this.product.cover = this.product.cover.map(cover=>{
          const disabled = cover.value === 'Hard Plastic Frosted Cover' ? true : false
          return {
            ...cover,
            disabled
          }
        })
      }

      //
      //If Discbound is selected disable Laminated Hard Cover
      //Enable Laminated Soft Cover and Frosted Cover
      if(value === "Disc Binding") {
        this.isSpiralSelected = false;
        this.isDiscBoundSelected = true;
        this.product.cover = this.product.cover.map(cover=>{
          const disabled = cover.value === 'Laminated Hard Cover'? true : false
          return {
            ...cover,
            disabled
          }
        })
      }
      /*
        If they click spiral - they should have both hard and soft cover available to select 
        But if they click discbound - they should only be able to select soft cover 
        This will be for the mini pocket planner only 
      */
     
     if((this.product.name === 'Mini Pocket Planner' || this.product.name === 'Mini Lined Journal')  && value === "Spiral/Coil"){
      this.isSpiralSelected = true;
        this.isDiscBoundSelected = false;
        this.product.cover = this.product.cover.map(cover=>{
          const disabled = cover.value === 'Hard Plastic Frosted Cover'? true : false
          return {
            ...cover,
            disabled
          }
        })
     }

     if((this.product.name === 'Mini Pocket Planner' || this.product.name === 'Mini Lined Journal')  && value === "Disc Binding"){
      this.isSpiralSelected = false;
        this.isDiscBoundSelected = true;
        this.product.cover = this.product.cover.map(cover=>{
          const disabled = cover.value === 'Laminated Hard Cover' || cover.value === 'Hard Plastic Frosted Cover'? true : false
          return {
            ...cover,
            disabled
          }
        })
     }


      
    },
    disableDiscColourTypeAccordingToBindingType() {
      // Decemeber 8th 2024 - There are shipping problems with the rest of colours of discs
      // for 12 Month Daily && 12 Month Task
      // when the situation stabilizes we can remove this check
      this.isDiscColourIssue = false

      if (!this.customizedProduct.binding) return
      if (!this.customizedProduct.cover) return

      const {
        binding: { value = null } = null,
        cover: { value: coverValue = null } = null,
      } = this?.customizedProduct

      if (
        (this.product.name === '12 Month Daily' ||
          this.product.name === '12 Month Task' || this.product.name === 'The Product') &&
        value === 'Disc Binding' &&
        coverValue === 'Hard Plastic Frosted Cover'
      ) {
        // Remove any exisiting selection
        this.isDiscColourIssue = true
        if (
          this.customizedProduct.discColour
        )
          delete this.customizedProduct.discColour

        this.product.discColours = this.product.discColours.map((colour) => {
          const disabled = colour.value === 'Clear' ? false : true

          return {
            ...colour,
            disabled,
          }
        })
      } else {
        // Remove any exisiting selection
        this.isDiscColourIssue = false


        this.product.discColours = this.product.discColours.map((colour) => {
          return {
            ...colour,
            disabled: false,
          }
        })
      }
    },
    openImageSizeComparisonDialog(){
      this.isImageSizeComparisonDialogVisible = true;
      
    },
    closeImageSizeComparisonDialog(){
      this.isImageSizeComparisonDialogVisible = false;
    },
    showCoverGraphicZoom(item) {
      try {
        this.generateLightBoxImages([
          item.pathCompressed ? item.pathCompressed : item.image,
        ])
        this.showLightBoxOnDom = true
        this.index = 0
      } catch (error) {
        console.error(error)
      }
    },
    saveGraphicSelection(graphic) {
      //https://codesource.io/how-to-dynamically-create-reactive-properties-in-vue/
      //https://vuejs.org/guide/extras/reactivity-in-depth.html#immutable-data
      this.$set(this.customizedProduct, 'coverGraphic', {}) //dynamically add reactive property to customizedProduct

      this.customizedProduct.coverGraphic = Object.assign({}, { ...graphic })

      this.$notify({ type: 'success', text: 'Cover graphic selected' })
    },
    addOptionToOrder(option) {
      this.$set(this.customizedProduct, 'selectedOption', {}) //dynamically add reactive property to customizedProduct

      this.customizedProduct.selectedOption = Object.assign({}, { ...option })

      this.$notify({ type: 'success', text: 'Option selected' })
      //this.getRealtimeStock(option)
    },
    getDate(value) {
      // value = YYYY-MM
      // October 2024, client requested that the year be included with the start month
      const month = value.split('-')[1]
      const year = value.split('-')[0]
      const p = parseInt(month) - 1

      // create copy of object other wise the original lookup array will be modified
      // this is noted when the user switches back and forth between months and the year keeps getting appended.
      const r = {...months[p]}

      const fullDate = `${r.value} - ${year}`
      r.value = fullDate

      this.customizedProduct.startMonth = { ...r, picker: value }
    },
    saveCustomization() {
      this.isCustomizationApplied = true
      this.$notify({ type: 'info', text: 'Layout customization saved' })
    },
    applyLayoutCustomization(val) {
      if (!val) {
        this.customizedProduct.spreadTextCustomization = {}
        delete this.customizedProduct.spreadTextCustomization
      }
    },
    showSpreadTextCustomizationDialog() {
      /*       if (this.customizedProduct?.spreadTextCustomization?.sections || null)
        return (this.isSpreadTextCustomizationDialogShowing = true) */
      const { price, sections } = this.product.spreadTextCustomization

      if (!this.customizedProduct.spreadTextCustomization) {
        this.$set(this.customizedProduct, 'spreadTextCustomization', {})
      }

      this.customizedProduct.spreadTextCustomization.value = true
      this.customizedProduct.spreadTextCustomization.price = price
      this.customizedProduct.spreadTextCustomization.sections = JSON.parse(
        JSON.stringify(sections)
      )
      //console.log(this.customizedProduct.spreadTextCustomization)
      this.isSpreadTextCustomizationDialogShowing = true
    },
    closeSpreadTextCustomizationDialog() {
      this.isSpreadTextCustomizationDialogShowing = false
    },
    closeAndCancelCustomization() {
      this.customizedProduct.spreadTextCustomization = {}
      delete this.customizedProduct.spreadTextCustomization
      this.isSpreadTextCustomizationDialogShowing = false
    },
    closeLightBox() {
      this.$refs.lightbox.closeLightBox()
      this.showLightBoxOnDom = false
    },
    async showCarouselImage(index, images) {
      try {
        this.generateLightBoxImages(images)
        await this.$nextTick()
        //this.showLightBoxOnDom = true
        //this?.$refs?.lightbox?.showImage(0) //open lightbox
        this.index = index
      } catch (error) {
        console.error(error)
      }
    },
    generateLightBoxImages(images) {
      /*       this.media = [
        {
          thumb: "https://images.unsplash.com/photo-1657299170935-31e068229885?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
          src: "https://images.unsplash.com/photo-1657299170935-31e068229885?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
        }
      ] */
      try {
        if (!images)
          this.media = [
            {
              // For image
              thumb: '',
              src: '',
              caption: 'Product image', // Optional - supports HTML
              // srcset: '...' // Optional for displaying responsive images
            },
          ]
        this.media = images.map((i) => {
          try {
            return {
              thumb: i,
              src: i,
              caption: 'Product image', // Optional - supports HTML
              // srcset: '...' // Optional for displaying responsive images
            }
          } catch (error) {
            console.error(error)
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    increaseOrderedQuantity() {
      const { orderedQuantity } = this.customizedProduct
      if (orderedQuantity >= 0 && orderedQuantity < 5)
        this.customizedProduct.orderedQuantity =
          this.customizedProduct.orderedQuantity + 1
    },
    decreaseOrderedQuantity() {
      const { orderedQuantity } = this.customizedProduct
      if (orderedQuantity > 0 && orderedQuantity <= 5)
        this.customizedProduct.orderedQuantity =
          this.customizedProduct.orderedQuantity - 1
    },
    async checkCoverType() {
      await this.$nextTick()
      const { binding, cover } = this.customizedProduct

      if (!binding?.bindingName) return
      if (!cover?.value) return

      const { bindingName } = binding
      const { value } = cover
      if (value === 'Laminate Hard Cover' && bindingName === 'Disc Binding') {
        this.customizedProduct.cover = null
      }
    },
    continueShopping() {
      this.showContinueShoppingDialog = false
      this.$router.push({ path: '/' })
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].intersectionRatio >= 0.5
    },
    updateText(val) {
      this.customizedProduct.personalizedText = val
    },
    addToCart() {
      try {
        const { product: p, customizedProduct: cp } = this
        /*         if(p.startMonth && !cp.startMonth.value)
          throw new Error('Please select start month') */
        if (
          p.isStartMonthSelectionEnabled &&
          !cp.startMonth.value &&
          cp.datedLayout.value === 'Dated'
        )
          throw new Error(
            'Start month must be chosen if Dated layout is select'
          )
        if (p.size && !cp.size) throw new Error('Please select size')
        if (p.layout && !cp.layout) throw new Error('Please select layout')
        if (p.plannerLayout && !cp.plannerLayout)
          throw new Error('Please select planner layout')
        if (p.datedLayout && !cp.datedLayout)
          throw new Error('Please select dated/undated layout')
        if (p.isStartDaySelectionEnabled && !cp.startDay)
          throw new Error('Please select start day')
          if (p.isStartMonthSelectionEnabled && !cp.startMonth)
          throw new Error('Please select start month')
        if (p.quality && !cp.quality)
          throw new Error('Please select paper quality')
        if (p.binding && !cp.binding)
          throw new Error('Please select binding type')
        if (p.cover && !cp.cover) throw new Error('Please select cover type')
        //spiral colour
        if (p.spiralColours?.length && !cp.spiralColour && this.discColourDisable) throw new Error('Please select spiral colour')
        //disc colour
        if (p.discColours?.length && !cp.discColour && this.sprialColourDisable) throw new Error('Please select disc colour')
        
        if (p.coverGraphic && !cp.coverGraphic) 
          throw new Error('Please select cover design')
        if (p.isPouchAvailable && !cp.pouchCustomization)
          throw new Error('Please select pouch option')
        if (p.isGiftWrappingAllowed && !cp.wrappingOption)
          throw new Error('Please select wrapping option')
        if (p.isAddOnPocketAllowed && !cp.addOnPocket)
          throw new Error('Please select add on pocket option')
        if (cp.personalizedText && cp.personalizedText.length > 240)
          throw new Error(
            'Personalization text is over 240 character limit. Please reduce character count'
          )

        this.isAddingToCart = true
        this.addToVuexCart({
          ...this.customizedProduct,
          itemTotal: this.itemTotal,
          product: this.product,
        })
        this.$notify({
          // (optional)
          // Title (will be wrapped in div.notification-title)
          title: 'Cart addition successful',

          // Content (will be wrapped in div.notification-content)
          //text: 'This is some <b>content</b>',

          // (optional)
          // Class that will be assigned to the notification
          type: 'success',

          // (optional, override)
          // Time (in ms) to keep the notification on screen
          duration: 5000,

          // (optional, override)
          // Time (in ms) to show / hide notifications
          //speed: 1000,

          // (optional)
          // Data object that can be used in your template
          //data: {}
        })

        this.itemAdded = {
          ...this.customizedProduct,
          product: this.product,
        }
        this.showContinueShoppingDialog = true
        this.isAddingToCart = false
      } catch (error) {
        console.error(error)
        this.isAddingToCart = false
        this.$notify({
          text: error,
          type: 'error',
          duration: 10000,
        })
      }
    },
    removeProductFromCart() {
      try {
        this.removeProductFromVuexCart({ ...this.selectedProduct })
      } catch (error) {
        console.error(error)
      }
    },
  },
  async fetch() {
    const payload = this.$nuxt.context.payload

    if (payload) return (this.product = { ...payload })

    const { link } = this.$nuxt.context.params

    try {
      const p = await this.getProductFromDbWithLinkName(link)

      this.product = { ...p }
    } catch (error) {
      console.error(error)
    }
  },
  fetchOnServer: process.env.NODE_ENV !== 'development',
}
